import {Injectable} from "@angular/core";
import {NotificationMessageService} from "@ispm/core/components/customise-notification/notifications-message.service";
import {NotificationMessageButton} from "@ispm/core/interfaces/notification-message-button.interface";
import {NotificationMessageTypes} from "@ispm/core/constants/notification-message-types.constant";


@Injectable()
export class ExportNotificationService {
  constructor(private notificationMessageService: NotificationMessageService) {

  }

  public setNotificationMessage(notificationType: string, text: string, messageParam: any = null, time: number = null, body: string = null, keepNotifications: boolean = false, isCloseAll: boolean = false, isSticky: boolean = false, buttons: Array<NotificationMessageButton> = []) {
    if (isCloseAll)
      this.notificationMessageService.closeAllNotifications();

    text = text && messageParam && messageParam.textToReplace ? text.replace(messageParam.textToReplace, messageParam.value) : text;
    body = body && messageParam && messageParam.textToReplace ? body.replace(messageParam.textToReplace, messageParam.value) : body;

    switch (notificationType) {
      case NotificationMessageTypes.INFO: {
        this.notificationMessageService.info(text, time, body, keepNotifications, isSticky, buttons);
        break;
      }
      case NotificationMessageTypes.SUCCESS: {
        this.notificationMessageService.success(text, time, body, keepNotifications, isSticky, buttons);
        break;
      }
      case NotificationMessageTypes.ERROR: {
        this.notificationMessageService.error(text, time, body, keepNotifications, isSticky, buttons);
        break;
      }
      case NotificationMessageTypes.WARN: {
        this.notificationMessageService.warning(text, time, body, keepNotifications, isSticky, buttons);
        break;
      }
    }
  }
  }
